import { Location } from "gen/company/models_pb"

import { data } from "./data"
import { TypedAccessor } from "./types"
import { Chip } from "../../../../components/base/informational/Chip"
import { TableCellWidth } from "../TableCell"
import { DataColumn } from "../useTable/types"

type LocationAccessorFn<T> = TypedAccessor<T, Location | undefined>
type LocationColumn<T> = Omit<DataColumn<T>, "type" | "renderCell">
export type LocationColumnHelper<T> = (
  accessorFn: LocationAccessorFn<T>,
  col?: LocationColumn<T>
) => DataColumn<T>

export function location<T>(
  accessorFn: LocationAccessorFn<T>,
  col?: LocationColumn<T>
): DataColumn<T> {
  return data({
    renderCell: (rowData) => {
      const location = accessorFn(rowData)
      if (location === undefined) return null
      return (
        <div className="flex items-center gap-x-2">
          <Chip color="gray" text={location.prefix} />
          <span>{location.name}</span>
        </div>
      )
    },
    title: col?.title ?? "Location",
    width: col?.width ?? TableCellWidth.ExtraExtraLarge,
  })
}
